import React, { useMemo, useState, useEffect } from 'react';
import './App.css';
import ChatDrawer from './ChatDrawer';
import { checkEmbedAllowed } from './embedAllowed';

function App() {
  const [embedState, setEmbedState] = useState(() => ({ allowed: true }));

  useEffect(() => {
    setEmbedState(checkEmbedAllowed());
  }, []);

  const blockedMessage = useMemo(() => {
    if (embedState.allowed) return null;
    return embedState.reason || 'Embedding is not allowed from this page.';
  }, [embedState]);

  return (
    <div className="App app-embed-root">
      {embedState.allowed ? (
        <ChatDrawer />
      ) : (
        <div className="embed-blocked" role="status">
          <p>{blockedMessage}</p>
        </div>
      )}
    </div>
  );
}

export default App;
